import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './svg/drag.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-65566286")

_pushScopeId("data-v-65566286")
const _hoisted_1 = { class: "tag-all" }
const _hoisted_2 = {
  class: "tag-new",
  id: "tag-new"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "添加标签集", -1)
const _hoisted_4 = { class: "form" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "tag-set-name-label" }, "标签集", -1)
const _hoisted_6 = { class: "tag-set-type" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("工单")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("人员")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("知识库")
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "tag-set-value-label" }, "标签集值", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "left" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "right" }, null, -1)
const _hoisted_14 = {
  key: 1,
  src: _imports_0,
  style: {"cursor":"not-allowed","margin-right":"5px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_16 = { class: "buttons-box" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("提交")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", null, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            class: ["tag-set-name-input", {
            duplicated: _ctx.isLabelSetNameDuplicated
          }],
            modelValue: _ctx.tagSet.labelSetName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tagSet.labelSetName = $event))
          }, null, 8, ["modelValue", "class"]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.tagSet.useForTicket,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tagSet.useForTicket = $event))
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.tagSet.useForUser,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.tagSet.useForUser = $event))
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.tagSet.useForRepository,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tagSet.useForRepository = $event))
            }, {
              default: _withId(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _hoisted_10,
          _createVNode("div", {
            class: "tag-set-value-list",
            onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args))),
            ref: "scroll"
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tagSetLabels, (v, i) => {
              return (_openBlock(), _createBlock(_Fragment, { key: i }, [
                _createVNode("div", {
                  class: ["drag-guard", i === _ctx.dropIndex ? 'active' : '']
                }, [
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13
                ], 2),
                _createVNode("div", {
                  class: "tag-set-value-item",
                  onDragover: _withModifiers(($event: any) => (_ctx.handleDragOver($event, i)), ["prevent"])
                }, [
                  (i !== _ctx.tagSetLabels.length - 1)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: _imports_0,
                        draggable: "true",
                        style: {"cursor":"move","margin-right":"5px"},
                        onDragstart: ($event: any) => (_ctx.dragStart($event, i))
                      }, null, 40, ["onDragstart"]))
                    : (_openBlock(), _createBlock("img", _hoisted_14)),
                  _createVNode(_component_el_input, {
                    onInput: ($event: any) => (_ctx.addInputIfNeed($event, i)),
                    placeholder: "请填写选项",
                    modelValue: _ctx.tagSetLabels[i].name,
                    "onUpdate:modelValue": ($event: any) => (_ctx.tagSetLabels[i].name = $event),
                    class: {
                  duplicated: _ctx.labelNameCount[v.name] > 1
                }
                  }, null, 8, ["onInput", "modelValue", "onUpdate:modelValue", "class"]),
                  _hoisted_15,
                  _createVNode(_component_el_input, {
                    onInput: ($event: any) => (_ctx.addInputIfNeed($event, i)),
                    placeholder: "附加信息，非必要可以不填",
                    modelValue: _ctx.tagSetLabels[i].extraName,
                    "onUpdate:modelValue": ($event: any) => (_ctx.tagSetLabels[i].extraName = $event),
                    class: {
                  duplicated: _ctx.labelNameCount[v.name] > 1
                }
                  }, null, 8, ["onInput", "modelValue", "onUpdate:modelValue", "class"]),
                  (i !== _ctx.tagSetLabels.length - 1)
                    ? (_openBlock(), _createBlock("i", {
                        key: 2,
                        onClick: ($event: any) => (_ctx.deleteTag(i)),
                        class: "el-icon-close"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 40, ["onDragover"])
              ], 64))
            }), 128))
          ], 544)
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
          default: _withId(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _ctx.submit,
          type: "primary"
        }, {
          default: _withId(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
})